<template>
<!--  <div ref="loading" id="loading" v-show="isShow">-->
  <div ref="loading" id="loading">
    <div class="loading__indicator">
      <img class="loading__indicatorImg" src="/img/loading.png" alt="" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "Loading",
  // computed: {
  //   isShow() {
  //     return this.$store.state.common.loading;
  //   }
  // },
  created() {
    Vue.prototype.$loading = this;
  },
  mounted() {
    const loading = this.$refs.loading;
    loading.style.width = window.innerWidth + "px";
    loading.style.height = window.innerHeight + "px";
  },
  methods: {
    show() {
      // this.isShow = true;
      this.$refs["loading"].className = "show";
    },
    hide() {
      // this.isShow = false;
      this.$refs["loading"].className = "";
    },
    check(){
      console.log("loading element", this.$refs["loading"].className);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
div#loading
    position: fixed
    //@include fit
    z-index: $z_loading
    @include flexCenter()
    background-color: rgba(0, 0, 0, 0.8)
    .loading__indicator
        transform: scale(0.5)
    .loading__indicatorImg
      animation: loadingAnim 1s infinite steps(16)
    display: none
    &.show
      display: flex
@keyframes loadingAnim
  0%
    transform: rotate(0)
  100%
    transform: rotate(360deg)
</style>
